import { CssBaseline, ThemeProvider } from "@mui/material";
import type { ReactNode } from "react";
import { useEffect, useMemo } from "react";
import { createMuiThemeFromConfig } from "@/app/theme/createMuiThemeFromConfig";
import { applyCssVariables, getThemeConfig } from "@/config/themes";
import { useResolvedThemeMode } from "@/features/appearance/hooks/useResolvedThemeMode";

type AppThemeProviderProps = {
  children: ReactNode;
};

export function AppThemeProvider({ children }: AppThemeProviderProps) {
  const mode = useResolvedThemeMode();
  const themeConfig = useMemo(() => getThemeConfig(mode), [mode]);
  const muiTheme = useMemo(() => createMuiThemeFromConfig(themeConfig), [themeConfig]);

  useEffect(() => {
    applyCssVariables(themeConfig);
  }, [themeConfig]);

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
